"use client";
import { useEffect } from "react";
import { setOriginalScrollY, setIsOverlayOpen } from "@/store/overlaySlice";
import { useAppDispatch } from "@/store/hooks";

interface OverlayProps {
  open: boolean;
  onClose: React.MouseEventHandler<HTMLDivElement>;
}

export function Overlay({ open, onClose }: OverlayProps) {
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (open) {
      const scrollY = window.scrollY;
      dispatch(setOriginalScrollY(scrollY));
      dispatch(setIsOverlayOpen(true));

      // lock body
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = "100%";

      return () => {
        // unlock body
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.width = "";
        window.scrollTo(0, scrollY);
        dispatch(setIsOverlayOpen(false));
      };
    }
  }, [open, dispatch]);

  if (!open) return null;

  return (
    <>
      <div
        className="fixed inset-0 z-40 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 h-screen w-screen"
        onClick={onClose}
      />
    </>
  );
}
